/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import React, { useEffect } from 'react';
import { Container, Typography, Breadcrumbs } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { WritingRuleEditor } from './WritingRuleEditor';
import { writingRuleActions } from '@ink-ai/portal/reducers/wirting-rule';

export const CreateWritingRule = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<any>();

  useEffect(() => () => dispatch(writingRuleActions.resetAll()), []);

  return (
    <Container maxWidth="lg" sx={{ mt: 1, mb: 1 }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
        <Link to="/">{t('writingRules.navigation.home')}</Link>
        <Link to="/writing-rule">
          {t('writingRules.navigation.writingRule')}
        </Link>
        <Typography color="textPrimary">
          {t('writingRules.navigation.create')}
        </Typography>
      </Breadcrumbs>
      <WritingRuleEditor />
    </Container>
  );
};
